import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-primary text-center text-white mt-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container p-4" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "mb-4" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "btn btn-outline-light btn-floating m-1",
      href: "https://github.com/ososuna/pokedex.git",
      target: "_blank",
      role: "button"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fab fa-github" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("section", { class: "mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: "https://fontmeme.com/permalink/220303/53e6f4184809d9dbe6e98062a0948a4e.png",
          alt: "vue-pokedex",
          width: "120"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "vue pokedex just for fun"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-white",
      style: {"text-decoration":"none"},
      href: "https://github.com/ososuna",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code" }),
      /*#__PURE__*/_createTextVNode(" ososuna ")
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}